export enum DateState {
	ThereIs,
	AtTheAge,
	Date,
	AtYear
}
